import { NotFoundState } from "@/components/page-states";
import { Link } from "@shared/client/navigation";
import { usePageTitle } from "@shared/client/view";
import { Button } from "@shared/components/ui/button";
import { useT } from "@shared/client/locale";

export default function NotFoundPage() {
  const t = useT();
  const copy = t.common.states.notFoundPage;
  usePageTitle(t.common.pageTitles.notFound);
  return (
    <main className="grid min-h-screen place-items-center bg-background px-4">
      <div className="grid max-w-[420px] gap-4 text-center">
        <h1 className="m-0 font-serif text-[32px] leading-tight font-normal tracking-tight">{copy.title}</h1>
        <p className="m-0 text-[13.5px] text-muted-foreground">{copy.body}</p>
        <Button asChild className="justify-self-center">
          <Link href="/app">{copy.back}</Link>
        </Button>
      </div>
    </main>
  );
}

/** Adresse inconnue sous /app : le 404 reste dans la coque, rail et topbar compris. */
export function AppNotFoundPage() {
  usePageTitle(useT().common.pageTitles.notFound);
  return <NotFoundState />;
}
